import {
  Alert,
  AlertSection,
  AlertsCommentary,
  alertRequiresNavAttention,
  schAlertTrigger,
} from '@aloft/toolkit-shared';

import { MutableRefObject } from 'react';

import { processAlertTrigger, retriggerAlertToasts } from '../../redux/features/uiSlice.ts';
import { AppDispatch } from '../../redux/types.ts';

const COMPARABLES_UPDATE_TRIGGER = schAlertTrigger.enum['update/comparables'];

export const dispatchComparablesPageAlertTrigger = (
  dispatch: AppDispatch,
  alertsRef: MutableRefObject<Record<AlertSection, Alert[]>>,
  alertsCommentary?: AlertsCommentary,
) => {
  requestAnimationFrame(() => {
    const alertsPerSection = alertsRef.current;
    dispatch(
      processAlertTrigger({
        trigger: COMPARABLES_UPDATE_TRIGGER,
        alertsPerSection,
        alertsCommentary,
      }),
    );

    const matchingAlertTypes = Object.values(alertsPerSection)
      .flat()
      .filter(
        (alert) =>
          alert.triggers.includes(COMPARABLES_UPDATE_TRIGGER) &&
          alertRequiresNavAttention(alert, alertsCommentary),
      )
      .map((alert) => alert.type);

    if (matchingAlertTypes.length > 0) {
      dispatch(retriggerAlertToasts(matchingAlertTypes));
    }
  });
};
